const adminTypes = {
  platform: 'platform',
  establishment: 'establishment',
};

export default adminTypes;
